import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-63e5d8fc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fast-selection" };
const _hoisted_2 = { class: "fast-selection__header" };
const _hoisted_3 = { class: "fast-selection__title" };
const _hoisted_4 = { class: "fast-selection__subtitle" };
const _hoisted_5 = { class: "fast-selection__buttons" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportationFastSelection',
    props: {
        groups: {}
    },
    emits: ["select-group", "select-all"],
    setup(__props, { emit }) {
        const selectGroup = (key) => {
            emit('select-group', key);
        };
        const onSelectAll = () => {
            emit('select-all');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('audiences.exportation.fast-selections')), 1),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('audiences.exportation.click-on-buttons')), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
                        return (_openBlock(), _createElementBlock("button", {
                            key: group.key,
                            class: "btn",
                            onClick: _withModifiers(($event) => (selectGroup(group.key)), ["prevent"])
                        }, _toDisplayString(group.name), 9, _hoisted_6));
                    }), 128)),
                    _createElementVNode("button", {
                        class: "btn",
                        onClick: _withModifiers(onSelectAll, ["prevent"])
                    }, _toDisplayString(_ctx.$t('all')), 9, _hoisted_7)
                ])
            ]));
        };
    }
});
